import { ArrowRight } from 'lucide-react'
import React from 'react'
import { cn } from '#app/utils/misc.tsx'

interface InteractiveHoverButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	text?: string
	children?: React.ReactNode
}

const InteractiveHoverButton = React.forwardRef<
	HTMLButtonElement,
	InteractiveHoverButtonProps
>(({ text, children, className, ...props }, ref) => {
	const content = children ?? text ?? 'Button'

	return (
		<button
			ref={ref}
			className={cn(
				'group/btn cursor-pointer rounded-full px-6 py-2 text-center font-semibold text-white transition-all duration-300 ease-out hover:-translate-x-1 hover:pl-8 hover:pr-6',
				className,
			)}
			style={{
				background: 'linear-gradient(135deg, #f6921e 0%, #eb008b 100%)',
			}}
			{...props}
		>
			{/* Button content with icon */}
			<span className="inline-flex items-center">
				<span>{content}</span>
				<span className="inline-flex w-0 overflow-hidden transition-all duration-300 ease-out group-hover/btn:w-6">
					<ArrowRight className="ml-2 h-4 w-4" />
				</span>
			</span>
		</button>
	)
})

InteractiveHoverButton.displayName = 'InteractiveHoverButton'

export { InteractiveHoverButton }
